export interface Review {
  id: number;
  title: string;
  detail: string;
  nickname: string;
  ratings: {
    vote_id: number;
    rating_id: number;
    rating_name: string;
    percent: number;
    value: number;
  }[];
  review_entity: string;
  review_type: number;
  review_status: ReviewStatus;
  created_at: string;
  entity_pk_value: number;
  store_id: number;
  stores: number[];
}

export interface Rating {
  rating_id: string;
  entity_id: string;
  rating_code: string;
  position: string;
  is_active: string;
  entity_code: string;
  options: Option[];
}

export interface Option {
  option_id: string;
  rating_id: string;
  code: string;
  value: string;
  position: string;
}

export enum ReviewStatus {
  Approved = 1,
  Pending = 2,
  NotApproved = 3,
}
